import { render, staticRenderFns } from "./GraphDetail17.vue?vue&type=template&id=5bf9c24a&scoped=true&"
import script from "./GraphDetail17.vue?vue&type=script&lang=js&"
export * from "./GraphDetail17.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf9c24a",
  null
  
)

export default component.exports